// extracted by mini-css-extract-plugin
export default {"outgoing":"Outgoing_outgoing__1+vaA","declined":"Outgoing_declined__7JJBY"};